<template>
  <div id="page-client-maps-form">
    <vs-row >
      <vs-col>
        <card-page
            card-title="Create a Client Map"
        >
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              class="mt-4"
              :schema="schema"
              :model="model"
              :options="formOptions"
              ref="form"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { selectOptions } from '@/components/form/FormElementOption';
import FormModelMixin from "../../../components/mixins/FormModelMixin";
import CardPage from '../../components/Views/CardPage';

export default {
  name: "ClientMapForm",
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  mixins: [FormModelMixin],
  components: {
    CardPage
  },
  data() {
    return {
      model: {
        CompanyProducer_FK: null,
        SalesCountryType_FK: null,
        Product_FK: null,
        OnlineRaterConnectionType_FK: null,
        RemoteSignature_PC: null,
        ManualSignature_PC: null,
        AffinityRemoteSignature_PC: null,
        AffinityManualSignature_PC: null,
        ConsultancyFee_PC: null,
        DiscretionaryLoading_PC: null,
        IsConsultancyFeeAllowed: 0,
      },
      schema: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Company",
                model: "CompanyProducer_FK",
                required: true,
                validator: 'required',
                values: () => this.companies.map(( company ) => {
                  return {
                    id: company.id,
                    name: `${company.CompanyCode} - ${company.name}`,
                  }
                }),
                selectOptions
              },
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Country",
                model: "SalesCountryType_FK",
                values: () => this.countries.map(( country ) => {
                  return {
                    id: country.id,
                    name: country.name,
                  }
                }),
                selectOptions
              },
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Product",
                model: "Product_FK",
                required: true,
                validator: 'required',
                values: () => this.products.map(( product ) => {
                  return {
                    id: product.id,
                    name: `${product.ProductCode} - ${product.name}`,
                  }
                }),
                selectOptions
              },
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Connection Type",
                model: "OnlineRaterConnectionType_FK",
                values: () => this.connectionTypes.map(( connectionType ) => {
                  return {
                    id: connectionType.id,
                    name: connectionType.name,
                  }
                }),
                selectOptions
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "Remote Signature %",
                model: "RemoteSignature_PC",
                required: true,
                min: 0,
                validator: ['positive', 'numeric'],
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "Manual Signature %",
                model: "ManualSignature_PC",
                required: true,
                min: 0,
                validator: ['positive', 'numeric'],
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "Affinity Remote Signature %",
                model: "AffinityRemoteSignature_PC",
                required: true,
                min: 0,
                validator: ['positive', 'numeric'],
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "Affinity Manual Signature %",
                model: "AffinityManualSignature_PC",
                required: true,
                min: 0,
                validator: ['positive', 'numeric'],
              },
              {
                type: "vsCheckbox",
                styleClasses: "w-1/3",
                label: "Is Consultancy Fee Allowed?",
                model: "IsConsultancyFeeAllowed",
                default: false,
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "Consultancy Fee %",
                model: "ConsultancyFee_PC",
                required: true,
                validator: ['positive', 'numeric'],
              },
              {
                type: "input",
                inputType: "number",
                styleClasses: "w-1/3",
                label: "DLDD %",
                model: "DiscretionaryLoading_PC",
                required: true,
                validator: ['positive', 'numeric'],
              },
            ]
          }
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      companies: [],
      products: [],
      countries: [],
      connectionTypes: [],
      options: [
        {
          endpoint: () => this.$api.companies.list(),
          optionsFieldName: "companies",
          nameFieldName: "CompanyName",
          idFieldName: 'CompanyProducer_FK',
          additionalFields: [
              'CompanyCode',
          ],
        },
        {
          endpoint: () => this.$api.products.list(),
          optionsFieldName: "products",
          nameFieldName: "ProductDescription",
          idFieldName: 'Product_FK',
          additionalFields: [
            'ProductCode',
          ],
        },
        {
          endpoint: () => this.$api.clientMap.listSalesCountries(),
          optionsFieldName: "countries",
          nameFieldName: "label",
          idFieldName: 'SalesCountryType_FK',
        },
        {
          endpoint: () => this.$api.clientMap.listConnectionTypes(),
          optionsFieldName: "connectionTypes",
          nameFieldName: "label",
          idFieldName: 'OnlineRaterConnectionType_FK',
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
